import { useRef } from 'react';

let nextName: number = 0;

/**
 * Returns the name passed in, or a stable unique name otherwise.
 */
export function useUniqueName(name?: string): string {
  const nameRef = useRef('');
  if (name && nameRef.current !== name) {
    nameRef.current = name;
  } else if (!nameRef.current) {
    nameRef.current = `unique-name-${nextName}`;
    nextName++;

    if (nextName === Number.MAX_SAFE_INTEGER) {
      nextName = Number.MIN_SAFE_INTEGER;
    }
  }

  return nameRef.current;
}
